// FLAGS: identity
// The app's only `localStorage` accessor for registration state: the server-issued unconfirmed-data
// signature that email confirmation replays, and an `isNewUser` marker.
const unconfirmedDataIdentifier = "unconfirmedDataSignature";
const isNewUserIdentifier = "isNewUser";

// FLAGS: identity
// Persists the server-issued registration signature to `localStorage`, where it outlives the tab and
// survives sign-out — nothing removes it. Two callers store two different shapes; see MODULE.md.
const setUnconfirmedDataSignature = (unconfirmedDataId) =>
  localStorage.setItem(
    unconfirmedDataIdentifier,
    JSON.stringify(unconfirmedDataId),
  );
const getUnconfirmedDataSignature = () =>
  localStorage.getItem(unconfirmedDataIdentifier);

const setIsNewUser = () => localStorage.setItem(isNewUserIdentifier, "true");
const getIsNewUser = () => localStorage.getItem(isNewUserIdentifier) === "true";
const removeIsNewUser = () => localStorage.removeItem(isNewUserIdentifier);

const service = {
  setUnconfirmedDataSignature,
  getUnconfirmedDataSignature,
  setIsNewUser,
  getIsNewUser,
  removeIsNewUser,
};

export default service;
